module.exports = __webpack_public_path__ + "media/images/grey_tick-682d8609bec0fa253f44387abdf8b4d6.svg";